import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    CircularProgress,
    IconButton,
    Box
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import ButtonOmni from './ButtonOmni'; // Adjust import path as needed

const useStyles = makeStyles(theme => ({
    deleteDialog: {
        '& .MuiDialog-paper': {
            borderRadius: '16px',
            padding: '0',
            minWidth: '420px',
            backgroundColor: theme.palette.background.paper,
        }
    },
    deleteDialogTitle: {
        padding: '20px 24px 12px 24px',
        borderBottom: `1px solid ${theme.palette.type === 'dark' ? '#404042' : '#e0e0e0'}`
    },
    titleRow: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '12px'
    },
    deleteDialogContent: {
        padding: '8px 24px 24px 24px'
    },
    deleteDialogActions: {
        padding: '16px 24px',
        gap: '12px',
        justifyContent: 'flex-end'
    },
    deleteDialogText: {
        fontSize: '15px',
        color: theme.palette.secondary.value,
        lineHeight: '1.6'
    },
    titleText: {
        fontWeight: '600',
        fontSize: '20px',
        color: theme.palette.text.primary
    },
    closeButton: {
        color: theme.palette.text.primary,
        padding: 4
    },
    loadingWrapper: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
    }
}));

function DeleteConfirmationDialog({
    open,
    onClose,
    onConfirm,
    title = 'Delete Item',
    message = 'Are you sure you want to delete this item?',
    confirmLabel = 'Delete',
    cancelLabel = 'Cancel',
    maxWidth = 'xs',
    loading = false
}) {
    const classes = useStyles();
    const theme = useTheme();

    return (
        <Dialog
            open={open}
            onClose={(event, reason) => {
                if (loading) return;
                if (reason === 'backdropClick') return;
                onClose();
            }}
            maxWidth={maxWidth}
            className={classes.deleteDialog}
        >
            <DialogTitle className={classes.deleteDialogTitle} disableTypography>
                <Box className={classes.titleRow}>
                    <Typography className={classes.titleText}>
                        {title}
                    </Typography>
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        size="small"
                        disabled={loading}
                        className={classes.closeButton}
                    >
                        <CloseIcon />
                    </IconButton>
                </Box>
            </DialogTitle>
            <DialogContent className={classes.deleteDialogContent}>
                <Typography className={classes.deleteDialogText}>
                    {message}
                </Typography>
            </DialogContent>
            <DialogActions className={classes.deleteDialogActions}>
                <ButtonOmni
                    onClick={onClose}
                    variant="outlined"
                    label={cancelLabel}
                    disabled={loading}
                />
                <ButtonOmni
                    onClick={onConfirm}
                    variant="outlined"
                    label={confirmLabel}
                    loading={loading}
                    disabled={loading}
                />
            </DialogActions>
        </Dialog>
    );
}

export default DeleteConfirmationDialog;